import {PositionsAPI} from "../api/PositionsAPI"
import {AppStore} from "../desktop"
import {actionPositionFetchAllCompleted, actionPositionFetchCompleted} from "../store/positions/actions"
import {BaseService} from "./BaseService"
import {Position} from "../models/Position"
import {PositionsActionTypes} from "../store/positions"
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions"
import {ErrorService} from "./ErrorService"
import {actionToastrInfo} from "../store/global"

export default class PositionsService extends BaseService {

	static getAll() {

        let positionsAPI: PositionsAPI = new PositionsAPI()

		positionsAPI.getAll().then(PositionsService.processResponse)
		.then((result) => actionPositionFetchAllCompleted(PositionsService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(position: Position) {

        let positionsAPI: PositionsAPI = new PositionsAPI()

        positionsAPI.get(position).then(PositionsService.processResponse).then(result => {
			actionPositionFetchCompleted(PositionsService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(position: Position) {

        let positionsAPI: PositionsAPI = new PositionsAPI()

		if (position.id) {
			positionsAPI.put(PositionsService.itemToRequest(position)).then(PositionsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: PositionsActionTypes.SAVE_COMPLETED, payload: PositionsService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
					actionSetTabStateItem(PositionsService.fromAPIItem(data))
					actionSetTabItem(PositionsService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			positionsAPI.post(PositionsService.itemToRequest(position)).then(PositionsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: PositionsActionTypes.SAVE_COMPLETED, payload: PositionsService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
					actionSetTabStateItem(PositionsService.fromAPIItem(data))
					actionSetTabItem(PositionsService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		}
	}

	static delete(position: Position) {

        let positionsAPI: PositionsAPI = new PositionsAPI()

		positionsAPI.delete(PositionsService.itemToRequest(position)).then(PositionsService.processResponse).then(
			(data) => {
				actionToastrInfo("Info", "Podaci su uspešno obrisani")
				AppStore.dispatch({
					type: PositionsActionTypes.DELETE_COMPLETED, payload: position
				})
				actionDeleteTabForItemId(position.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(positions: Position[]) {

		let positionsAPI: PositionsAPI = new PositionsAPI()
		let count = 0;
		positions.forEach(position => {

			positionsAPI.delete(PositionsService.itemToRequest(position)).then(PositionsService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(position.id)
					actionToastrInfo("Info", "Podaci su uspešno obrisani")
					if(count === positions.length)
						AppStore.dispatch({
							type: PositionsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: positions
						})
				}
			).catch(error => ErrorService.handleError(error))
		});
	}

    static fromAPIList(apiList: any): Position[] {
        const localList = apiList.map((apiItem: any) => PositionsService.fromAPIItem(apiItem));
        //console.info('[fromAPIPositionList] converted positions: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Position{
        let position = new Position();

        position.id = apiItem.id;
        position.title = apiItem.name;
		position.description = apiItem.description;
		position.departmentId = apiItem.departmentId

        return position;
    }

    static itemToRequest (position: Position): any {

		let itemRequest: any = {};

		if(position.id)
        itemRequest.id = position.id;

		itemRequest.name = position.title;
		itemRequest.description = position.description;
		itemRequest.departmentId = position.departmentId

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}
}
